import { t } from '../i18n';

// 验证CIDR格式
export const validateCIDR = (cidr) => {
    // 分离 IP 和前缀长度
    const parts = cidr.split('/');
    if (parts.length !== 2) {
        return false;
    }

    const ip = parts[0];
    const prefixLength = parseInt(parts[1], 10);

    // 验证IPv4 CIDR
    if (/^(\d{1,3}\.){3}\d{1,3}$/.test(ip)) {
        // 验证IPv4地址是否有效
        const octets = ip.split('.');
        for (let i = 0; i < octets.length; i++) {
            const octet = parseInt(octets[i], 10);
            if (octet < 0 || octet > 255) {
                return false;
            }
        }
        return prefixLength >= 0 && prefixLength <= 32;
    }

    // 验证IPv6 CIDR
    // 使用更宽松的IPv6验证，接受压缩格式
    if (/^([0-9A-Fa-f]{0,4}:){2,7}([0-9A-Fa-f]{0,4})?$/.test(ip) ||
        /^::([0-9A-Fa-f]{0,4}:){0,6}([0-9A-Fa-f]{0,4})?$/.test(ip) ||
        /^([0-9A-Fa-f]{0,4}:){0,6}::([0-9A-Fa-f]{0,4}:){0,6}([0-9A-Fa-f]{0,4})?$/.test(ip)) {
        return prefixLength >= 0 && prefixLength <= 128;
    }

    return false;
};

// 验证域名格式（支持IDN国际化域名）
export const validateDomain = (domain) => {
    if (!domain || typeof domain !== 'string') return false;

    // 去除首尾空格
    domain = domain.trim().toLowerCase();

    // 检查是否包含非ASCII字符（IDN域名）
    const hasNonAscii = /[^\x00-\x7F]/.test(domain);

    if (hasNonAscii) {
        // IDN域名验证：至少有一个点，每个部分不为空，不以点开头或结尾
        const parts = domain.split('.');
        if (parts.length < 2) return false;
        if (parts.some(p => p.length === 0)) return false;
        // 检查每个部分不能以连字符开头或结尾
        if (parts.some(p => p.startsWith('-') || p.endsWith('-'))) return false;
        return true;
    }

    // ASCII域名或Punycode域名验证
    // 支持 xn-- 开头的Punycode域名
    const asciiPattern = /^[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*\.[a-z]{2,}$/;
    const punycodePattern = /^(xn--[a-z0-9-]+\.)*[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*\.[a-z]{2,}$/;

    return asciiPattern.test(domain) || punycodePattern.test(domain);
};

// 验证域名格式（用于表单规则，返回Promise）
export const validateDomainRule = (_, value) => {
    if (!value) {
        return Promise.reject(new Error(t('Please enter a domain')));
    }
    if (validateDomain(value)) {
        return Promise.resolve();
    }
    return Promise.reject(new Error(t('Enter a valid domain')));
};

// 验证IPv4地址
export const validateIPv4 = (ip) => {
    const pattern = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/;
    return pattern.test(ip);
};

// 验证IPv6地址
export const validateIPv6 = (ip) => {
    const pattern = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]+|::(ffff(:0{1,4})?:)?((25[0-5]|(2[0-4]|1?[0-9])?[0-9])\.){3}(25[0-5]|(2[0-4]|1?[0-9])?[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1?[0-9])?[0-9])\.){3}(25[0-5]|(2[0-4]|1?[0-9])?[0-9]))$/;
    return pattern.test(ip);
};

// 验证IP地址（IPv4或IPv6）
export const validateIP = (ip) => {
    return validateIPv4(ip) || validateIPv6(ip);
};

// 验证邮箱格式
export const validateEmail = (email) => {
    const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return pattern.test(email);
};

// 验证手机号格式
export const validatePhone = (phone) => {
    const pattern = /^1\d{10}$/;
    return pattern.test(phone);
};
